export class User {
  username: string;
  password: string;
}

export class AuthResponse {
  isAuthSuccessful: boolean;
  errorMessage: string;
  token: string;
}
